"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var themes_1 = require("../../themes");
var BlockLabel_1 = require("../../v2/components/BlockLabel");
var getBlockLabelProps_1 = require("../../utils/getBlockLabelProps");
var CheckboxInput_1 = require("../RadioAndCheckbox/comps/CheckboxList/comps/CheckboxInput");
var DatePicker_1 = __importDefault(require("../DatePicker"));
var styled_1 = require("./styled");
function DateRangePicker(props) {
    var onChange = props.onChange, value = props.value, id = props.id, readOnly = props.readOnly, futureDateOnly = props.futureDateOnly, previousDateOnly = props.previousDateOnly, allowPresentlyOngoing = props.allowPresentlyOngoing, invert = props.invert, disabled = props.disabled, debug = props.debug;
    var currentDate = new Date(new Date().toLocaleDateString());
    var handleOnChange = function (i, v) {
        var newValue = value ? __spreadArray([], value, true) : [];
        newValue[i] = v;
        onChange && onChange(id, newValue);
    };
    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
        react_1.default.createElement(BlockLabel_1.BlockLabel, __assign({}, (0, getBlockLabelProps_1.getBlockLabelProps)(props))),
        react_1.default.createElement(styled_1.StyledDateRangeInputWrapper, { invert: invert, readOnly: readOnly },
            react_1.default.createElement(DatePicker_1.default, { id: 0, value: value && value[0], onChange: handleOnChange, readOnly: readOnly, futureDateOnly: futureDateOnly, previousDateOnly: previousDateOnly, invert: invert, disabled: disabled }),
            react_1.default.createElement(styled_1.StyledDateRangeInputDivider, null, "-"),
            react_1.default.createElement(DatePicker_1.default, { id: 1, from: value && value[0] ? new Date(value[0]) : currentDate, futureDateOnly: futureDateOnly, previousDateOnly: previousDateOnly, value: value && (value[1] === null ? 'Ongoing' : value[1]), onChange: handleOnChange, readOnly: readOnly, disabled: value && value[1] === null ? true : disabled ? true : false, invert: invert, debug: debug })),
        !readOnly && allowPresentlyOngoing && (react_1.default.createElement("div", { style: { marginTop: '1rem' } },
            react_1.default.createElement(CheckboxInput_1.CheckboxInput, { option: { display: 'Presently Ongoing', value: 'Ongoing' }, value: value && value[1] === null
                    ? [{ display: 'Presently Ongoing', value: 'Ongoing' }]
                    : [], onClick: function (isSelected) {
                    return handleOnChange(1, isSelected ? undefined : null);
                }, invert: invert })))));
}
exports.default = react_1.default.memo(DateRangePicker);
